import { FC, useMemo } from 'react';
import { Row, Col } from 'antd';
// import cs from 'classnames';
// import styles from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/Charts/index.module.less';
import styles from '@/common/components/business/PassengerFlowPortrait/components/index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';

// import BarChart from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/Charts/BarChart';
import BarChart from '@/common/components/business/PassengerFlowPortrait/components/BarChart';
// import HistoryRate from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/Charts/HistoryRate';
import HistoryRate from '@/common/components/business/PassengerFlowPortrait/components/HistoryRate';
// import { getDateTwoMonthsAgo } from '@/common/utils/ways';
import { isArray } from '@lhb/func';

// const dataLimit = getDateTwoMonthsAgo();

/**
 * @Description 经营业态
 */
const TypeOfBusiness: FC<{
  detail: any
}> = ({
  detail
}) => {
  const showBusinessDistributions = useMemo(() => {
    const { businessDistributions, historyBusinessDistributions } = detail || {};
    return (isArray(businessDistributions) && businessDistributions.length) || (isArray(historyBusinessDistributions) && historyBusinessDistributions.length);
  }, [detail]);
  return (
    <div className={styles.chartsContainer}>
      <V2Title divider type='H2' text='业态分析'
        extra={
          <span className={styles.tips}>数据更新时间截止{detail?.updateDataMonth || ''}，与当前开店数据不完全一致。</span>
        }
      />
      {/* 没有就不显示 */}
      <div className={styles.desc}> {detail?.businessDistributionsIntro || ''} </div>
      <Row gutter={16}>
        <Col span={12}>
          {showBusinessDistributions
            ? <HistoryRate
              list={detail?.businessDistributions || []}
              historyList={detail?.historyBusinessDistributions || []}
            />
            : ''
          }
        </Col>
        <Col span={12}>
          {
            isArray(detail.businessDistributions) && detail.businessDistributions.length ? <BarChart detail={detail}/> : <></>
          }
        </Col>
      </Row>
    </div>
  );
};

export default TypeOfBusiness;
